import { useSelector } from 'react-redux';
import { User } from '../types/user';

export const useCurrentUser = () => {
  return useSelector((state: any) => state.user.user as User);
};

export const useIsLister = () => {
  const user = useCurrentUser();
  return user.job_title === 'Lister';
};
